;(function() {
    var bestshopMain = {
        init: function(){
            var self = this;
            self.$wrapper = $('.bestshop-wrapper');

            switch(self.$wrapper.data('content')) {
                case 'main' : self.main(); break;
                case 'reserveSearch' : self.search(); break;
                case 'event' : self.event(); break;
            };

            self.bindEvent();
        },
        bindEvent: function(){
            var self = this;
            
            self.$wrapper.find('a').filter('[data-target]').each(function() {
                var _attr = {};
                var _href = $(this).attr('data-url');
                
                if($(this).hasClass('disabled')) {
                    _attr = {
                        'href' : 'javascript:void(0)'
                    }
                }else {
                    if($(this).attr('data-target') == '01') {
                        _attr = {
                            'href'  : _href,
                            'target': 'lgetobestshop',
                            'title' : 'BESTSHOP 새창열림'
                        };
                    }else {
                        _attr = {
                            'href' : _href
                        }
                    }
                }
                $(this).attr(_attr);
            });
            self.$wrapper.find('.btnPopClose').off().on("click", function() {
                self.$heroSlide.find('.custom-indi-wrap').find('.ui_carousel_play.play').trigger('click');
                var popId = $(this).parents(".popup").attr("id");
                var prevPopId = $(".popup[data-open-popup-id='" + "#" + popId + "']");
                var prevPopAttr = prevPopId.attr("data-open-popup-id");
                $(this).parents(".popup").stop().fadeOut(100).removeClass("on over");
                $(this).parents(".popup").find(".pop-cont").removeAttr("style");
                $(this).parents(".popup").removeAttr("data-open-popup-id").removeAttr("tabindex");
                $("[href='" + "#" + popId + "']").focus();
                $(".popup").each(function(index){
                    var popZindex = 9005 + index;
                    if ( $(this).is(".on") && $(this).attr("data-open-popup-id") != prevPopAttr ){
                        $(this).css("z-index", 998);
                    }
                    else {
                        $(this).css("z-index", popZindex);
                        $(".dim").css("z-index", 999);
                    };
                });
                if ( $(".popup.on").length < 1 ){
                    $("html").removeAttr("style");
                };
                $(".dim").stop().fadeOut(100);

            });
            self.$wrapper.find('.btn-shop-map').off().on("click", function(e) {
                e.preventDefault();
                // BTOCSITE-15539 앱인 경우 window.open 떴을때 뒤로가기 안되서 모바일은 자창이동
                var target = this.getAttribute('href'),
                    popupWidth = parseInt(this.getAttribute('data-width')),
                    popupHeight = parseInt(this.getAttribute('data-height')),
                    screenWidth = parseInt(screen.width),
                    screenHeight = parseInt(screen.height),
                    intLeft = Math.floor((screenWidth - popupWidth) / 2),
                    intTop = Math.floor((screenHeight - popupHeight) / 2);
        
                if (intLeft < 0) intLeft = 0;
                if (intTop < 0) intTop = 0;
                if(vcui.detect.isMobile) {
                    location.href = target;
                } else {
                    window.open(target, '_blank', 'width=' + popupWidth + ',height=' + popupHeight + ',left=' + intLeft + ',top=' + intTop + ',history=no,resizable=no,status=no,scrollbars=yes,menubar=no');
                }
            });

            if(isApp()) {
                $(document).on('click', 'a[target="lgetobestshop"]', function(e){
                    e.preventDefault();
                    var appUrl = $(this).attr('href');
                    if (!(appUrl.match('https://'))) {
                        appUrl = 'https://'+window.LGEAPPHostName+appUrl;
                    } 
                    if(vcui.detect.isIOS){
                        //IOS 인앱브라우저
                        var obj = new Object();
                        obj.command = 'openNewInAppBrowser';
                        obj.url = appUrl;
                        obj.titlebar_show = 'Y'; //탑바 노출여부
                        obj.bottombar_show = 'Y'; //하단바 노출여부
                        var jsonString= JSON.stringify(obj);
                        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                    } else {
                        android.openNewWebview(appUrl, true /*탑바 노출여부*/, true /*하단바 노출여부*/);
                    }
                })
            }
        },
        main: function() {
            var self = this;
            if(vcui.detect.isIE) self.$wrapper.find('.sub-main').addClass('ie');
            
            // swiper 기본 UI에 있는 파일과 bestshop에서 사용중인 파일 버전이 다름
            var config = (vcui.detect.isIE) ? ['ui/carousel', 'libs/swiper_v4.min']:['ui/carousel', 'https://bestshop.lge.co.kr/lg5-common-best/js/libs/swiper-bundle.min.js'];
            vcui.require( config , function () {
                self.hero();
                self.store();
                self.story(); //BTOCSITE-32703 닷컴홈페이지 베스트샵 UI/UX 개선 요청
                self.notice();  //[전시][BTOCSITE-90034][베스트샵] 행사매장 안내 영역 및 띠배너 위치 변경 요청(닷컴 요청)
            });
            window.videoPop = self.videoPop;
        },
        hero: function(){
            var self = this;
            self.$heroSlide = self.$wrapper.find(".hero-banner");
            var $indicator = self.$heroSlide.find(".custom-indi-wrap");
            var $slideCurrent = $indicator.find(".current");
            var $totalCount = $indicator.find(".count");

            self.$heroSlide
            .on('carouselinit', function(e, slide){
                $(slide.$slides).each(function(i) {
                    if($(this).find('video').size()>0 && i !== 0) {
                        $(this).find('video').each(function() {
                            if(this.readyState>0 && this.hasAttribute('autoplay')) {
                                this.pause();
                            }
                        })
                    }
                });
                if(slide.slideCount > 1) {
                    $indicator.show();
                    $slideCurrent.html('<span class="blind">현재 페이지</span>' + (slide.currentSlide + 1));
                    $totalCount.html('<span class="blind">총 페이지 수</span>' + slide.slideCount);
                }
            })
            .vcCarousel({
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipeToSlide: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 100,
                cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                speed: 150
            })
            .on('carouselafterchange', function(e, slide, prev, next){
                $slideCurrent.html('<span class="blind">현재 페이지</span>' + (slide.currentSlide + 1));

                var $slider = $(slide.$slider);
                var autoSpeed = $slider.data('autoSpeed') ? $slider.data('autoSpeed') : 3000;
                if($(slide.$slides).find('video').length > 0) { //BTOCSITE-81608 [모니터링 G][PC] 버튼은 "pause" 상태이지만 슬라이드의 비디오는 계속 실행 중임. ( video 갯수 체크 구문 수정 )
                    $(slide.$slides).find('video').get(0).pause();
                    if($(slide.$slides).eq(slide.currentSlide).find('video').length>0) { //BTOCSITE-81608 [모니터링 G][PC] 버튼은 "pause" 상태이지만 슬라이드의 비디오는 계속 실행 중임. ( video 갯수 체크 구문 수정 )
                        $(this).find('video').filter(':visible').each(function() {
                            if(this.readyState>0 && this.hasAttribute('autoplay')) {
                                autoSpeed =	this.duration * 1000;
                                this.currentTime = 0;
                                this.play();

                                //BTOCSITE-81608 [모니터링 G][PC] 버튼은 "pause" 상태이지만 슬라이드의 비디오는 계속 실행 중임. ( video 상태 체크 if 영역에 버튼 상태 변경 스크립트 추가 )
                                $(this).parent().find(".video-button-wrap button.video-button").removeClass("play");
                                $(this).parent().find(".video-button-wrap button.video-button").addClass("pause");
                            }
                        })
                        $slider.vcCarousel('setOption', 'autoplaySpeed', autoSpeed);
                    }
                }
                
            })

        },
        store: function() {
//            var self = this;
//            var introFlagList = $("#introFlagList").val();
//            var bullet = introFlagList.substring(1, introFlagList.length-1).split(",");
//            var target = {
//                swiper: '.slide-store',
//                tab: (vcui.detect.isIE) ? '.slide-store .tab-pager, .slide-store .slide-navi .pager-pagination':'.slide-store .tab-pager',
//                indi: '.slide-store .slide-navi .pager-pagination'
//            };
//
//            /* BTOCSITE-32703 닷컴홈페이지 베스트샵 UI/UX 개선 요청 */
//            bullet.forEach(function(el){
//                $('.tab-pager').append('<div class="swiper-pagination-bullet"><button type="button">'+ el +'</button></div>')
//            });
//            
//            if(vcui.detect.isIE) return false;
//            self.$storSlidepaging = new Swiper(target.swiper, {
//                speed : 800,
//                centeredSlides: true,
//                paginationClickable: true,
//                loop: true,
//                pagination: {
//                    el: target.indi,
//                    clickable: true
//                },
//                breakpoints: {
//                    768: {
//                        slidesPerView: 1
//                    },
//                    1380: {
//                        slidesPerView: 'auto',
//                    }
//                },
//                on: {
//                    slideChange: function (swiper) {
//                        //$(target.tab).find('.swiper-pagination-bullet').eq(this.activeIndex).trigger('click');
//                        var idx = swiper.realIndex;
//                        var _ths = parseInt($('.slide-store .tab-pager').children().eq(idx).offset().left) - 16.5;
//                        var _thsLeft = $('.info-store .slide-store .tab-pager').scrollLeft();
//
//                        $('.info-store .slide-store .tab-pager').scrollLeft(_ths + _thsLeft);
//                        
//                        $('.slide-store .tab-pager').find('.swiper-pagination-bullet-active').removeClass('swiper-pagination-bullet-active');
//                        $('.slide-store .tab-pager').children().eq(idx).addClass('swiper-pagination-bullet-active');
//                    }
//                },
//            });
//            //self.$storSlide.controller.control = storSlidepaging;
//
//            $('.slide-store .tab-pager button').click(function(){
//                var _ths = parseInt($(this).offset().left) - 16.5;
//                var _thsLeft = $('.info-store .slide-store .tab-pager').scrollLeft();
//                $('.info-store .slide-store .tab-pager').scrollLeft(_ths + _thsLeft);
//                
//                var idx = $(this).parent('.swiper-pagination-bullet').index();
//                $(this).parents(".tab-pager-wrap").prev(".slide-navi").find(".swiper-pagination-bullet").eq(idx).trigger("click");
//             
//            });
        },
        story: function() {
            var showYn = $(".bestshop-sns .sns-slide").find(".swiper-slide").length;
            if (showYn <= 1) {
                $(".sns-slide").addClass("no-swiper");
                $(".sns-slide").next(".slide-navi").remove();
            } else {
                $('.sns-slide').addClass('swiper-ally-custom'); // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵
                var snsSlide = new Swiper(".sns-slide", {
                    autoplay: true,
                    loop: true,
                    loopSlides: 1,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    pagination: {
                        el: ".bestshop-sns .slide-navi .pager-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".bestshop-sns .slide-navi .slideBtn.btn-next",
                        prevEl: ".bestshop-sns .slide-navi .slideBtn.btn-prev"
                    },
                    on: {
                        // [S] BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵
                        /*slideChange: function () {
                            $('.left-cont').stop().fadeOut(100);
                        },
                        init : function () {
                            $('.left-cont').stop().fadeIn();
                            if($('.left-cont em').text() != ""){
                                $('.left-cont em').css("visibility","visible");	
                            }else{
                                $('.left-cont em').css("visibility","hidden");
                            }
                        }*/
                        slideChangeTransitionEnd: function() {
                            $(this.slides).each(function() {
                                var $this = $(this);
                                
                                if ($this.hasClass('swiper-slide-active')) {
                                    $this.attr('aria-hidden','false');
                                    $this.removeAttr('inert');
                                } else {
                                    $this.attr('aria-hidden','true');
                                    $this.attr('inert', '');
                                }
                            });
                        }
                        // [E] BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵
                    }
                });
                snsSlide.update();
                //snsSlide.init();

                $(window).on('resize', function () {
                    snsSlide.update();

                });


                snsSlide.on('transitionEnd', function(){
                    var i = parseInt(snsSlide.realIndex),
                        _ths = $('.sns-slide .swiper-slide').eq(i),
                        _thsTit = _ths.find('strong').html(),
                        _thsDesc = _ths.find('span').text(),
                        _thsCate = _ths.find('em').text(),
                        _thsLink = _ths.find('a').attr('href'),
                        _thsLinkTxt = _ths.find('a').text(),
                        _thsLinkTarget = _ths.find('a').attr('target')

                    function changeEv(){
                        $('.left-cont strong').html(_thsTit);
                        $('.left-cont span').text(_thsDesc);
                        if(_thsCate != ""){
                            $('.left-cont em').text(_thsCate).css("visibility","visible");	
                        }else{
                            $('.left-cont em').css("visibility","hidden");
                        }
                        
                        $('.left-cont .btn-area a .linkhref').attr('href', _thsLink).text(_thsLinkTxt);
                        $('.left-cont .btn-area a').attr('href', _thsLink);
                        $('.left-cont .btn-area a').attr('target', _thsLinkTarget);
                        $('.left-cont').stop().fadeIn();
                    }
                    changeEv();
                });

                // autoplay control
                $('.bestshop-sns .swiper-auto > button').on('click', function(){
                    $('.bestshop-sns .swiper-auto > button').toggleClass('active');

                    if($(this).hasClass('btn-play')){
                        snsSlide.autoplay.start();
                    } else {
                        snsSlide.autoplay.stop();
                    }
                });
            }
            /* //BTOCSITE-32703 닷컴홈페이지 베스트샵 UI/UX 개선 요청 */
        },
        // S [전시][BTOCSITE-90034][베스트샵] 행사매장 안내 영역 및 띠배너 위치 변경 요청(닷컴 요청)
        notice : function(){
            var mainNotice = new Swiper(".notice-slide", {
                loop: true,
                autoplay: true,
                direction: 'vertical',
                navigation: {
                    nextEl: ".main-notice .slideBtn.btn-next",
                    prevEl: ".main-notice .slideBtn.btn-prev",
                },
                a11y: {
                    slideRole: 'region',
                    slideLabelMessage: '{{index}}번째 항목 / 총 {{slidesLength}}개 항목',
                    prevSlideMessage: '',
                    nextSlideMessage:'',
                },
                on: {
                    afterInit: function() {
                        var swiperThis = $(this.el);
    
                        swiperThis.find('.swiper-slide').attr('aria-hidden', 'true').find('*').attr('tabindex', '-1');
                        swiperThis.find('.swiper-slide-active').attr('aria-hidden', 'false').find('*').attr('tabindex', '0');
                    },
                    transitionEnd: function() {
                        var swiperThis = $(this.el);
    
                        swiperThis.find('.swiper-slide').attr('aria-hidden', 'true').find('*').attr('tabindex', '-1');
                        swiperThis.find('.swiper-slide-active').attr('aria-hidden', 'false').find('*').attr('tabindex', '0');
                    },
                }
            });
    
            // autoplay control
            $('.main-notice .swiper-auto > button').on('click', function(){
                $('.main-notice .swiper-auto > button').toggleClass('active');
    
                if($(this).hasClass('btn-play')){
                    mainNotice.autoplay.start();
                } else {
                    mainNotice.autoplay.stop();
                }
            });
        },
        // E [전시][BTOCSITE-90034][베스트샵] 행사매장 안내 영역 및 띠배너 위치 변경 요청(닷컴 요청)
        videoPop: function(pcVideoPath, mobileVideoPath) {
            $('.hero-banner').find('.custom-indi-wrap').find('.ui_carousel_play.stop').trigger('click');
            if($(window).width() < 1025){
                var moVide = $('#popup-video').css('display', 'block').find('video.mobileOnly').get(0);
                moVide.src = mobileVideoPath;
                // console.log("moVide.src :: " + moVide.src);
                // moSource.load();
                moVide.currentTime=0;
                moVide.play();
            } else {
                var pcVide = $('#popup-video').css('display', 'block').find('video.pcOnly').get(0);
                pcVide.src = pcVideoPath;
                // console.log("pcVide.src :: " + pcVide.src);
                // pcSource.load();
                pcVide.currentTime=0;
                pcVide.play();
            }
        },
        search: function() {
            var self = this;
            // BTOCSITE-74661 START
            
            var timer = null;
            var isRunning = false;
            var display = $(".valid-time");
            var target = '.bestshop-wrapper';
            var $userName = $(target).find("#userName");
            var $phoneNo = $(target).find("#phoneNo");
            var $verificationPopup = $("#popup-verification");
            var $userNamePopup = $verificationPopup.find('#userNamePopup');
            var $phoneNoPopup = $verificationPopup.find('#phoneNoPopup');
            var bestshopDomain = 'https://bestshop.lge.co.kr';
            var url = document.location.href;
            
            if (url.indexOf("wwwdev") !== -1 || url.indexOf("test.lge") !== -1) {
                bestshopDomain = "https://bestshopdev.lge.co.kr";
            } else if(url.indexOf("wwwstg") !== -1) {
                bestshopDomain = "https://bestshopstg.lge.co.kr";
            }
            // BTOCSITE-74661 END
            var register = {
                userName: {
                    minLength: 1,
                    maxLength: 30,
                    errorMsg: "이름을 입력해주세요.",
                    msgTarget: '.err-block',
                    pattern: /^[가-힣a-zA-Z\s]+$/, // BTOCSITE-74661
                },
                phoneNo: {
                    minLength:10,
                    // BTOCSITE-74661 START
                    maxLength: 11,
                    errorMsg: "휴대폰번호를 입력해주세요.",
                    msgTarget: '.err-block',
                    // BTOCSITE-74661 END
                },
            };
            // BTOCSITE-74661 START
            // validate reservation search form
            var validateForm = function() {
                var userName = ($userName).val();            
                var phoneNo = ($phoneNo).val();
                var isValidName = validateUsername(userName);
                var isValidPhone = validatePhoneNo(phoneNo);
                if (!isValidName) {
                    $userName.focus();
                } else if (!isValidPhone) {
                    $phoneNo.focus();
                }
                return isValidName && isValidPhone;
            }
            // validate username
            var validateUsername = function(value) {
                $("#userNameEmpty").hide();
                $("#userNameErr").hide();
                var valTest = new RegExp(register.userName.pattern);
                if (value.replace(/\s|　/gi, '').length === 0) {
                    $("#userNameEmpty").show();
                    return false;
                } if(!valTest.test(value)) {
                    $("#userNameErr").show();
                    return false;
                }
                return true;
            }
            // validate phoneNo
            var validatePhoneNo = function(value) {
                $("#phoneNoEmpty").hide();
                $("#phoneNoErr").hide();
                if (value.replace(/\s|　/gi, '').length === 0) {
                    $("#phoneNoEmpty").show();
                    return false;
                }
                // use validatePhone(value) === false because validatePhone function can return undefined when phone is valid
                if (validatePhone(value) === false) {
                    $("#phoneNoErr").show();
                    return false;
                }
                return true;
            }

            // Initial data & reset status of fields
            function initPopup() {
                display.html("");
                $("#codeEmptyErr").hide();
                $("#verifyFailErr").hide();
                $("#timeOutErr").hide();
                $("#certificationSend").prop("disabled", false);
                $("#timeExtension").prop("disabled", true);
                $("#certificationReSend").prop("disabled", true);
                $("#btnExtraDiv").hide();
                $("#insertRegist").attr("disabled", false);
                $("#verificationCode").prop("disabled", true);
                $("#verificationCode").val("");
                $userNamePopup.val($('#userName').val());
                $userNamePopup.attr('value', $('#userName').val()); // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵 // 휴대전화 인증 팝업 이름 inputbox value 수정
                $phoneNoPopup.val($('#phoneNo').val());
            }

            $("#userName").on('keyup', function (e) {
                if(e.keyCode == 13 || e.keyCode == 9 || e.keyCode == 16) {
                    return;
                }
                var chkStr = fnChkKorEng(fnChkByte($(this).val(), 30));
                $(this).val(chkStr);
                $("#userNameEmpty").hide();
                $("#userNameErr").hide();
            });

            $("#phoneNo").on('keyup', function (e) {
                if(e.keyCode == 13 || e.keyCode == 9 || e.keyCode == 16) {
                    return;
                }
                $("#phoneNoEmpty").hide();
                $("#phoneNoErr").hide();
            });

            // Check character is Kor/En/Space
            function fnChkKorEng(str) {
                var reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"|0-9]/gi;
                // Check regex for string
                if (reg.test(str)) {
                    str = str.replace(reg, "");
                }
    
                return str;
            }
            
            // Downsize the str to limit characters
            function fnChkByte(str, maxByte) {
                var strLen = str.length;
    
                var rbyte = 0;
                var rlen = 0;
                var oneChar = "";
                var str2 = "";
    
                for (var i = 0; i < strLen; i++) {
                    oneChar = str.charAt(i);
                    if (escape(oneChar).length > 4) {
                        rbyte += 2;
                    } else {
                        rbyte++;
                    }
                    if (rbyte <= maxByte) {
                        rlen = i + 1;
                    }
                }
                if (rbyte > maxByte) {
                    str2 = str.substr(0, rlen);
                    return str2;
                } else {
                    return str;
                }
            }
            
            // handle click send verification code
            $('#certificationSend, #certificationReSend').on('click', function() {
                $("#codeEmptyErr").hide();
                $("#verifyFailErr").hide();
                $("#timeOutErr").hide();
                var authPhoneNo = $("#phoneNo").val();
                // init timeout: 3 minutes
                var leftSec = 180;
    
                if (isRunning) {
                    clearInterval(timer);
                    display.html("");
                    startTimer(leftSec, display);
                } else {
                    startTimer(leftSec, display);
                }

                var $this = $(this);
                var btnId = $this.attr('id');
                var isReSend = (btnId == "certificationReSend");
                if (!isReSend) {
                    $("#certificationSend").prop("disabled", true);
                }

                var params = {
                    TEL_NO: authPhoneNo
                };

                // call send code
                $.ajax({
                    type: "POST",
                    url: "/bestshop/createAuthenticationNo.lgajax",
                    data: params,
                    dataType: "json",
                    success: function(res) {
                        if (res && res.data && res.data.data === 'success') {
                            $("#verificationCode").prop("disabled", false);
                            fnEnableBtn(isReSend, true)
                        } else {
                            $("#verificationCode").prop("disabled", true);
                            fnEnableBtn(isReSend, false)
                            clearInterval(timer);
                            display.html("");
                            isRunning = false;
                            lgkorUI.alert("", {
                                title: '인증코드 발송에 실패했습니다.<br>잠시 후 다시 시도해 주세요.'
                            }, $this);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        $("#verificationCode").prop("disabled", true);
                        fnEnableBtn(isReSend, false)
                        clearInterval(timer);
                        display.html("");
                        isRunning = false;
                        // show popup error
                        lgkorUI.alert("", {
                            title: '인증코드 발송에 실패했습니다.<br>잠시 후 다시 시도해 주세요.'
                        }, $this);
                    }
                });
            });
            
            // 시간 연장
            $('#timeExtension').on('click', function() {
                if (!isRunning) {
                    return;
                }
                var leftSec = 180;
                var params = {
                    TIME_EXTENSION_FLAG: "Y"
                };
                var $this = $(this);
                $.ajax({
                    type: "POST",
                    url: "/bestshop/createAuthenticationNo.lgajax",
                    data: params,
                    dataType: "json",
                    success: function(res) {
                        if (res && res.data && res.data.data === 'success') {
                            if (isRunning) {
                                clearInterval(timer);
                                display.html("");
                                startTimer(leftSec, display);
                            }
                        } else {
                            lgkorUI.alert("", {
                                title: '시간 연장이 실패했습니다.<br>잠시 후 다시 시도해 주세요.'
                            }, $this);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        lgkorUI.alert("", {
                            title: '시간 연장이 실패했습니다.<br>잠시 후 다시 시도해 주세요.'
                        }, $this);
                    }
                });
            });
            
            // 버튼 활성화/비활성화
            function fnEnableBtn(isReSend, isSuccess) {
                if (isReSend) {
                    // 인증번호 재발송
                    if (isSuccess) {
                        $("#timeExtension").prop("disabled", false);
                    } else {
                        $("#timeExtension").prop("disabled", true);
                    }
                } else {
                    // 인증번호 발송
                    if (isSuccess) {
                        $("#certificationSend").prop("disabled", true);
                        $("#timeExtension").prop("disabled", false);
                        $("#certificationReSend").prop("disabled", false);
                        $("#btnExtraDiv").show();
                    } else {
                        $("#certificationSend").prop("disabled", false);
                    }
                }
            }
            
            // Handle count down for Authentication code
            function startTimer(count, display) {  
                var minutes, seconds;
                timer = setInterval(function () {
                    minutes = parseInt(count / 60, 10);
                    seconds = parseInt(count % 60, 10);
    
                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;
                
                    display.html(minutes + ":" + seconds);
                    // Timeout 
                    if (--count < 0) {
                        clearInterval(timer);
                        $("#timeExtension").prop("disabled", true);
                        display.html("시간초과");
                        isRunning = false;
                    }
                }, 1000);
                isRunning = true;
            };

            // Handle click check reserve information
            $("#insertRegist").on('click', function() {
                $("#codeEmptyErr").hide();
                $("#verifyFailErr").hide();
                $("#timeOutErr").hide();
                
                var code = $("#verificationCode").val();
                if(code === null || code === "") {
                    $("#codeEmptyErr").show();
                    $("#verificationCode").focus();
                    return;
                }
                
                // If timeout, show error
                if(!isRunning) {
                    $("#timeOutErr").show();
                    $("#certificationReSend").focus();
                    return;
                }
                
                // Disable button util all API are completed
                $("#insertRegist").attr("disabled", true);
                
                // verify code
                verifyCode(function() {
                    if(!certResult) {
                        $("#verifyFailErr").show();
                        $("#verificationCode").focus();
                        $("#insertRegist").attr("disabled", false);
                        return;
                    }
                    searchReservationInfo();
                });
            });

            // Verify authentication code
            function verifyCode(callbackfunc) {
                var params = {
                    certNumber: $("#verificationCode").val(),
                    telNo: $("#phoneNo").val()
                };
                $.ajax({
                    type: "POST",
                    url: "/bestshop/verifyAuthenticationNo.lgajax",
                    data: params,
                    dataType: "json",
                    success: function(res) {
                        // validate Auth Code success
                        if(res && res.data && res.data.data === 'true') {
                            clearInterval(timer);
                            display.html("인증완료");
                            isRunning = false;
                            certResult = true;
                        } else {
                            certResult = false;
                        }
                        callbackfunc();
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        certResult = false;
                        callbackfunc();
                    }
                });
            }
            
            // Search reservation information after verify code success
            function searchReservationInfo() {
                
                var params = {
                    visitorName : $("#userName").val(),
                    visitorTelno : $("#phoneNo").val()
                }
                
                $.ajax({
                    url: "/bestshop/reservationCnt.lgajax",
                    type: "POST",
                    data: params,
                    error: function() {
                        // Handle error
                        $("#insertRegist").attr("disabled", false);
                    },
                    success: function(result) {
                        
                        $("#insertRegist").attr("disabled", false);
                        if (result && result.reservationCount > 0) {
                            $('#popup-verification .btn-close').click();
                            // Logic to redirect
                            if (loginFlag === 'Y' && userName === params.visitorName && userPhone === params.visitorTelno) {
                                window.location.href = myPageUrl;
                            } else {
                                var reserveSearchListUrl = bestshopDomain + '/reserveSearchList';
                                lgkorUI.pageGoPost({
                                    url: reserveSearchListUrl,
                                    target: '_self',
                                    params: [
                                        ['visitorName', $("#userName").val()],
                                        ['visitorTelno', $("#phoneNo").val()],
                                        ['memloginFlag', loginFlag],
                                    ]
                                });
                            }
                            
                        } else {
                            clearInterval(timer);
                            isRunning = false;
                            display.html("");
                            $("#codeEmptyErr").hide();
                            $("#verifyFailErr").hide();
                            $("#verificationCode").prop("disabled", true);
                            $("#verificationCode").val("");
                            $("html,body").css("overflow", "visible");
                            lgkorUI.alert("", {
                                title: '입력하신 고객님의 정보로<br>조회된 상담 예약 결과가 없습니다.',
                                okBtnName: '확인',
                                ok: function() {
                                    $('#popup-verification .btn-close').click();
                                }
                            }, $('.inq-box-area .btn-inq')[0]); // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵 팝업 close 후 포커스 이동
                        }
                    }
                });
            }

            $('#popup-verification .btn-close').on('click', function() {
                $(".btn-inq").focus();
            });

            // BTOCSITE-74661 END
            vcui.require(['ui/modal', 'ui/validation'], function () {
                // BTOCSITE-74661 START
    
                $(target).on('click','.btn-inq', function(e) {
                    e.preventDefault();
                    // BTOCSITE-74661 START
                    var validate = validateForm();
                    if(validate) {
                        initPopup();
                        $("#openCertificationPopup").click();
                    }
                    // BTOCSITE-74661 END
                });
            });

        }
        ,
        event: function() {
            var self = this;
            self.$KRP0022 = self.$wrapper.find('.KRP0022').first();
            self.target = {
                tab: self.$KRP0022.find('div.ui_tab'),
                list: self.$KRP0022.find('ul.box-list-inner'),
                select: self.$KRP0022.find('.ui_selectbox'),
                winner: $('#sortingWinner'),
                ongo: $('#eventOnGo'),
                partType: $('#typeCombo'),
            }
            self.page = 1;
            self.totalPage = 0;
            self.isLoading = false;
            
            /* [S] : BTOCSITE-30808 [모니터링] 베스트샵 이벤트 진입 시 필터영역 이상 노출 현상 */
            self.$KRP0022.find('.list-sorting').show();
            //
            
            vcui.require( ['ui/tab'] , function () {
                self.requestData(true);

                var isBottom = false, extraNum = ($('footer .foot-cont').height()) ? $('footer .foot-cont').height():0;
                $(window).off('scroll.eventScroll').on('scroll.eventScroll', function(){
                    isBottom = Math.round( $(window).scrollTop()) >= $(document).height() - $(window).height() - extraNum;
                    // 바닥까지 스크롤 되었는지 여부
                    if (isBottom && !self.isLoading) {
                        //만일 현재 마지막 페이지 라면
                        if(self.page == self.totalPage){
                            self.isLoading = false;
                            return; // 함수를 여기서 끝낸다.
                        }else{
                            self.isLoading = true;
                            //요청할 페이지 번호 1증가
                            self.page++;
                            self.requestData(true); // 리스트 조회
                        }
                    }
                })
            });

            self.target.tab.on("tabchange", function(e) {
                self.isInit = true;
                self.target.select.trigger('change_off');
                self.target.partType.prop("selectedIndex", 0).trigger('change');
                self.page=1;
                self.requestData(true);
                self.isInit = false;
            });
            self.target.select.on('change change_on change_off', function(e) {
                switch(e.type){
                    case "change" :
                        self.page=1;
                        if ( $(this).attr('id') == 'eventOnGo') {
                            if( $(this).val() === 'ongo' ){
                                self.target.winner.prop('checked', false);
                            }
                        }
                        if(!self.isInit) self.requestData(true);
                        break;
                    case "change_on" : 
                        self.target.winner.prop('checked', true);
                        if ($(this).attr('id') === 'eventOnGo') $(this).val('over').prop('selected', true).trigger('change');
                        break;
                    case "change_off" : 
                        self.target.winner.prop('checked', false);
                        if ($(this).attr('id') === 'eventOnGo') $(this).val('ongo').prop('selected', true).trigger('change');
                        break;
                }
            });
            self.target.winner.on('change', function(e) {
                if( $(this).is(':checked') ){
                    self.target.select.trigger('change_on');
                }else{
                    self.target.select.trigger('change_off');
                }
            });
        },
        requestData: function() {
            var self = this;
            var ajaxUrl = self.$KRP0022.attr('data-list-url');
            var eventTypeTab = self.target.tab.vcTab('instance');
            var postData={
                tabId: 'best',
                eventType: $(eventTypeTab.$tabs[eventTypeTab.selectedIndex]).attr('id'),
                ongo: self.target.ongo.val(),
                partType: self.target.partType.val(),
                winner: self.target.winner.is(':checked'),
                page: self.page,
                isMobile: vcui.detect.isMobile ? 'Y':'N',
            };
            // console.log('postData', postData)
            
            /* BTOCSITE-77417 웹앱 접근성 개선활동 */
            var tabTitle = $($(eventTypeTab.$tabs[eventTypeTab.selectedIndex]).html()).contents().eq(0).text();
            $("#tabContentsDesc").text(tabTitle + " 카테고리 이벤트 내용 시작");
            
            /* BTOCSITE-40459 닷컴 베스트샵 이벤트 페이지 tab 추가 요청 */
            // 클래스 tab 일때 유형전체 combo 미노출
            if($(eventTypeTab.$tabs[eventTypeTab.selectedIndex]).attr('id') == '09') {
            	$("#typeCombo").closest("div").hide();
            } else {
            	$("#typeCombo").closest("div").show();
            }
            
            lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(ajaxUrl, postData, function(result){
                // console.log('result', result)
                self.page = result.page;
                self.totalPage = result.totalPage;
                if(result.page == 1 || result.eventList.length == 0) self.target.list.empty();
                self.updateList(result.eventList);
                if(result.page < result.totalPage) {
                    self.isLoading = false;
                }
            });
        },
        updateList: function(data) {
            var self = this;
            var bestshopDomain = (self.$KRP0022.attr("data-bestshop-url")) ? self.$KRP0022.attr("data-bestshop-url"): 'https://bestshop.lge.co.kr/';
            var eventItemList = '<li class="lists"><div class="list-inner">' +
                '{{#if thumbnailLink  == null || thumbnailLink == ""}}' +
                '<a href="'+bestshopDomain+'/event/detail-{{eventNo}}" target="lgetobestshop" title="BESTSHOP 새창열림">' +
                '{{#else}}'+
                '<a href="{{thumbnailLink}}" {{#if thumbnailTarget == "Y"}} target="lgetobestshop" title="BESTSHOP 새창열림" {{/if}}>' +
                '{{/if}}'+
                    '<span class="thumb">' +
                        '<img src="'+bestshopDomain+'{{imagePath}}{{imageServerName}}" alt="">' +  // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵
                        '{{#if ongo == "over" || stFlag =="Y" }}<span class="event-end"><em>종료된 이벤트</em></span>{{/if}}' +
                        '<!-- {{#if partTypeNm == "타임딜" }}<span class="icon-timedeal"><img src="https://www.lge.co.kr/kr/bestshop/images/icon/icon-timedeal.svg" alt="타임딜" /></span>{{/if}} -->' +
                        '<!-- {{#if partTypeNm == "Live" }}<span class="icon-timedeal"><img src="https://www.lge.co.kr/kr/bestshop/images/icon/icon_live_show.svg" alt="live"></span>{{/if}} -->' +
                    '</span>' +
                    '<div class="info">' +
                        '<div class="flag-wrap bar-type"><span class="flag"><span class="blind">이벤트 구분</span>{{eventTypeNm}}</span><span class="flag"><span class="blind">이벤트 유형</span>{{partTypeNm}}</span></div>' +
                        '<p class="tit"><span class="blind">이벤트 제목</span>{{eventName}}</p>' +
                        '{{#if eventType  == "07" || partType =="05"}}' +
                        '<p class="date"><span class="blind">이벤트 기간</span>{{eventCalculTime}}</p>' +
                        '{{#else}}'+
                        '<p class="date"><span class="blind">이벤트 기간</span>{{eventFromDate}}~{{eventToDate}}</p>' +
                        '{{/if}}'+
                    '</div>' +
                '</a>' +
                '{{#if winnerYn != "N"}}<a href="{{#if eventNo}}'+bestshopDomain+'/event/winnerPop?eventNo={{eventNo}}{{/if}}" class="btn-link js-popup" data-width="1000" data-height="1000" title="새창열림"><span>당첨자 발표</span></a>{{/if}}' +  // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵
            '</div></li>';
            data.forEach(function(item, index) {
                item.eventCalculTime = '';
                if(item.eventType == "07" || item.partType == "05") {
                    var hour = item.eventFromHour;
					var hourTag = hour > 12 ? "오후" : "오전";
					var test = hour > 12 ? parseInt(hour)-12 : parseInt(hour);
                    item.eventCalculTime = item.eventFromDate+' '+hourTag+' '+test+'시';
                }
                // [S] [베스트샵][BTOCSITE-81999][모니터링] 베스트샵 이벤트 내 오타
                var _data = vcui.template(eventItemList, item);
                appendData = _data.replace(/&lt;/g, '<');
                appendData = appendData.replace(/&gt;/g,'>');
                appendData = appendData.replace(/&nbsp;/g,' ');
                self.target.list.append(appendData);
                // [E] [베스트샵][BTOCSITE-81999][모니터링] 베스트샵 이벤트 내 오타
            });
            self.noData(self.target.list.find('li').length > 0 ? false : true);
        },
        noData: function(visible) {
            var self = this;
            if(visible) {
                if(self.$KRP0022.find('.no-data').size() == 0) self.$KRP0022.append('<div class="no-data"><p>설정하신 필터에 맞는 이벤트가 없습니다.</p></div>');
                self.$KRP0022.find('.no-data').show()
            } else {
                self.$KRP0022.find('.no-data').hide()
            }
        }
    };

    // $(window).on('scroll', function(){
    //     var scrollTop = $(this).scrollTop()
    //     bestshopMain.scroll(scrollTop);
        
    // })

    $(window).on('load', function(){
        bestshopMain.init();
    });

})();

// BTOCSITE-60675 대표사이트 內 베스트샵 메인 히어로 영상 배너 확인 요청 건 
// 동영상 재생, 멈춤 버튼 조작
$(function(){ 
    var playBtn = $(".bestshop-wrapper .video-button");
    var screenWidth = $(window).width();

    for(var i = 0; i < playBtn.length; i++){
        var videoPlay = function(){
            var j = i;
            return function(){
                var pcVide = $('.bestshop-wrapper').find('video.pcOnly').get(j);
                var moVide = $('.bestshop-wrapper').find('video.mobileOnly').get(j);

                playBtn.eq(j).on("click",function(){

                    if($(this).hasClass("pause") && screenWidth > 767){
                        $(this).removeClass("pause");
                        $(this).addClass("play");
                        pcVide.pause();
                    }
                    else if($(this).hasClass("pause") && screenWidth <= 767){
                        $(this).removeClass("pause");
                        $(this).addClass("play");
                        moVide.pause();
                    }
                    else if($(this).hasClass("play") && screenWidth > 767){
                        $(this).removeClass("play");
                        $(this).addClass("pause");
                        pcVide.play();
                    }
                    else if($(this).hasClass("play") && screenWidth <= 767){
                        $(this).removeClass("play");
                        $(this).addClass("pause");
                        moVide.play();
                    }
                });
            }
        }
        var _videoControl = videoPlay();
        _videoControl();
    }
});

// BTOCSITE-62083 베스트샵 홈페이지 매장 홍보 영역 개편
(function(a){a.fn.rwdImageMaps=function(){var c=this;var b=function(){c.each(function(){if(typeof(a(this).attr("usemap"))=="undefined"){return}var e=this,d=a(e);a("<img />").on('load',function(){var g="width",m="height",n=d.attr(g),j=d.attr(m);if(!n||!j){var o=new Image();o.src=d.attr("src");if(!n){n=o.width}if(!j){j=o.height}}var f=d.width()/100,k=d.height()/100,i=d.attr("usemap").replace("#",""),l="coords";a('map[name="'+i+'"]').find("area").each(function(){var r=a(this);if(!r.data(l)){r.data(l,r.attr(l))}var q=r.data(l).split(","),p=new Array(q.length);for(var h=0;h<p.length;++h){if(h%2===0){p[h]=parseInt(((q[h]/n)*100)*f)}else{p[h]=parseInt(((q[h]/j)*100)*k)}}r.attr(l,p.toString())})}).attr("src",d.attr("src"))})};a(window).resize(b).trigger("resize");return this}})(jQuery);
$(document).ready(function(){$(".main-eventStore-map img[usemap]").rwdImageMaps();});
document.addEventListener("DOMContentLoaded",function(){
    var windowWidth = window.innerWidth;
    var storeImg = document.querySelector(".main-eventStore-map " + (window.innerWidth > 767 ? ".pc-only img" : ".mo-only img") );
    var storeImgSrc = storeImg.getAttribute("src").slice(0, storeImg.getAttribute("src").length-5);
    var storeLists = storeImg.nextElementSibling.querySelectorAll("area");
    storeLists.forEach(function(item,index){
        item.addEventListener("click",function(e){
            e.preventDefault();
            var url = "/bestshop/newShopList";
            
            window.location = url + "?storeIndex=" + index;
        });
        item.addEventListener("mouseover",function(){
            storeImg.setAttribute("src", storeImgSrc + (index+1).toString() + ".png");
        });
        item.addEventListener("mouseleave",function(){
            storeImg.setAttribute("src", storeImgSrc + "0" + ".png");
        });
    });
});

// BTOCSITE-65639 메인 리뷰 솔루션 연동 개발 건
(function(d, s) {
    var j, e = d.getElementsByTagName(s)[0], h = "https://cdn.attractt.com/embed_v2/index.js";
    if (typeof AttracttTower === "function" || e.src === h) { return; }
    j = d.createElement(s);
    j.src = h;
    j.async = true;
    e.parentNode.insertBefore(j, e);
})(document, "script");
